<div class="toggle-status">
    <freud-input-switch
    class="toggle-status__switch"
    [(ngModel)]="toggleModel"
    (valueChange)="onToggle()"
  ></freud-input-switch>
  <span>{{'MENU.TOGGLE' | translate }}</span>
</div>
<user-toggle-status-modal
  class="toggle-status__modal"
  [isOpen]="isToggleModalOpen"
  (onCancel)="isToggleModalOpen = false; onChangeStatus.emit(false)"
  (onToggle)="onChangeStatus.emit(true)"
 ></user-toggle-status-modal>